import { ApiResponse } from '../api'
import { axios } from '@src/lib/axios'

export interface LoginReqDto {
  /** 使用者帳號 */
  account: string;
  /** 密碼 */
  password: string;
}

export interface LoginRespDto {
  /** ID */
  uuid: string;
  /** 狀態 */
  status: string;
  /** 使用者姓名 */
  name: string | null;
  /** 使用者帳號 */
  account: string;
  /** 員工 UUID */
  employeeUuid: string | null;
  /** 角色ID */
  roleUuid: string;
  /** 電子郵件 */
  email: string | null;
  /** 手機 */
  mobile: string | null;
  /** 最後登入 */
  lastLogin: string | null;
  /** 備註 */
  note: string | null;
  /** 建立時間 */
  createdAt: string;
  /** 更新時間 */
  updatedAt: string;
  /** token */
  accessToken: string;
}

/** 登入 */
export async function login(reqDto: LoginReqDto): Promise<LoginRespDto> {
  const response = await axios.post<ApiResponse<LoginRespDto>>('/api/user/login', reqDto)

  const token = response.data.accessToken

  if (token) {
    axios.defaults.headers.Authorization = `Bearer ${token}`
  }

  return response.data;
}
